import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';

const HomeScreen = () => {
  return (
    <div className={styles.container}>
      <div
        className={styles.content}
        style={{
          backgroundImage: `url(${getImageFromS3('images/25-sms-prlm-if/bg.png')})`
        }}
      >
        <img
          className={styles.logo}
          src={getImageFromS3('images/25-sms-prlm-if/logo.png')}
          alt="logo"
        />
        <div className={styles.videoContainer}>
          <video
            className={styles.video}
            src={getImageFromS3('images/25-sms-prlm-if/video.mp4')}
            autoPlay
            loop
            muted
            playsInline
          />
        </div>
        <h1>Food Fest</h1>
        <h2>📍Тернопіль, Парк ім.Т.Г. Шевченка</h2>
      </div>
      <div className={styles.footer}>
        Куріння викликає серйозні захворювання та залежність Дана інформація про
        продукт надається відповідно до статті 15 Закону України «Про захист
        прав споживачів»
      </div>
    </div>
  );
};

export default HomeScreen;
